import { render, staticRenderFns } from "./ProductRecommendation.vue?vue&type=template&id=7ab2b2d9&scoped=true&"
import script from "./ProductRecommendation.vue?vue&type=script&lang=js&"
export * from "./ProductRecommendation.vue?vue&type=script&lang=js&"
import style0 from "./ProductRecommendation.vue?vue&type=style&index=0&id=7ab2b2d9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab2b2d9",
  null
  
)

export default component.exports